// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'normalize.css' // global css
import App from './App'
import router from './router'
import axios from 'axios'
import {apiGet, apiPost, apiGets, apiDelete} from './api'
import VueAMap from "vue-amap";


Vue.config.productionTip = false

Vue.prototype.$axios = axios
Vue.prototype.$apiGet = apiGet
Vue.prototype.$apiPost = apiPost
Vue.prototype.$apiGets = apiGets
Vue.prototype.$apiDelete = apiDelete

Vue.use(ElementUI)
Vue.use(VueAMap)

//地图
VueAMap.initAMapApiLoader({
  key: '195a644053ff99d3fe7e01233bcb7f98',						
  plugin: [
      'AMap.PlaceSearch', 'AMap.Geolocation'
      ],
  // 默认高德 sdk 版本为 1.4.4
  v: '1.4.4'
}); 
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js